import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "../../../hook/use-search-params";
import { Employee, EmployeeService } from "../../../services/department-viags/employee-viags.service";
import { useCallback, useMemo } from "react";

type EmployeeCheckType = Employee & { isView?: boolean; isEdit?: boolean };

const getIsView = (selectedEmployee: EmployeeCheckType[], eEmail: string) => {
  const isView = selectedEmployee.find((e) => e.employeeEmail.toLowerCase() === eEmail);
  return isView?.isView || false;
};

const getIsEdit = (selectedEmployee: EmployeeCheckType[], eEmail: string) =>
  selectedEmployee.find((e) => e.employeeEmail.toLowerCase() === eEmail)
    ? selectedEmployee.find((e) => e.employeeEmail.toLowerCase() === eEmail)?.isEdit
    : false;

export const useEmployeeByDepartment = () => {
  const { searchParams } = useSearchParams();
  const departmentCode = searchParams.get("deptCode") || "";

  const { data, ...res } = useQuery({
    queryKey: ["employee", departmentCode],
    queryFn: () => EmployeeService.getEmployeeList(departmentCode),
    enabled: !!departmentCode,
  });

  const employeeSelectData = useMemo(() => {
    if (!data) return [];
    return data.map((e) => ({ ...e, isView: false }));
  }, [data]);

  const getCheckEmployee = useCallback(
    (selectedEmployee: Employee[]) => {
      if (!data) return [];
      return data.map((e) => ({
        ...e,
        isView: getIsView(selectedEmployee, e?.employeeEmail?.toLowerCase()),
        isEdit: getIsEdit(selectedEmployee, e?.employeeEmail?.toLowerCase()),
      }));
    },
    [data],
  );

  return { data, employeeSelectData, getCheckEmployee, ...res };
};
